import { initActivityRemainderCronJob } from './activityRemainder.cron';
import { initCompanyCronJob } from './company.cron';
import { initTasksCronJob } from './tasks.cron';
import { initUnitHoldBookCron } from './unitHoldBook.cron';

export const initCronJobs = () => {
  initCompanyCronJob();

  initTasksCronJob();

  initUnitHoldBookCron();

  initActivityRemainderCronJob();
};
